
































































































































import Vue from 'vue'
import Modal from '@/components/Modal'
import fb from '../../firebase'
import LayoutPreview from '@/components/LayoutPreview'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import { Layout } from '@/types/layouts'
import { Tabs, TabPane, Table, TableColumn } from 'element-ui'
import './CreateLayout.scss'

// Validator
// @ts-ignore
const inArray = (_matches = (e, v) => e === v) =>
  function (value) {
    // @ts-ignore
    const others = this.layouts.filter(layout => {
      return layout.name === value
    })
    return others.length === 0
  }

export default Vue.extend({
  name: 'CreateLayout',
  props: {
    show: {
      type: Boolean
    },
    layouts: {
      type: Array as () => Layout[]
    }
  },
  data: () =>({
    name: '',
    info: '',
    existingLayout: '',
    kisweLayouts: [] as Layout[],
    submitStatus: '',
    activeTab: 'kiswe',
    copyFromExisting: false,
    errorCopyFromExisting: false
  }),
  computed: {
    existingLayouts (): Layout[] {
      if (this.activeTab === 'kiswe') {
        return this.kisweLayouts
      } else {
        return this.layouts
      }
    }
  },
  mounted (): void {
    fb.db.collection('layouts').where('team_id', '==', 'all').onSnapshot(snaps => {
      this.kisweLayouts = []
      for (const layoutdoc of snaps.docs) {
        const layout = layoutdoc.data() as Layout
        this.kisweLayouts.push({ id: layoutdoc.id, ...layout })
      }
    }, error => {
      console.error('Could not get layout templates ', error)
    })
  },
  validations: {
    name: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(40),
      noDouble: inArray()
    },
    info: {
      maxLength: maxLength(175),
    }
  },
  methods: {
    formSubmitted () {
      this.$v.$touch()
      this.errorCopyFromExisting = false
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'
      } else if (this.existingLayout === '' && this.copyFromExisting) {
        this.submitStatus = 'ERROR'
        this.errorCopyFromExisting = true
      } else {
        let copyLayout: Layout|undefined = undefined
        if (this.existingLayout !== '') {
          if (this.activeTab === 'kiswe') {
            copyLayout = this.kisweLayouts.find(layout => layout.id === this.existingLayout)
          } else {
            copyLayout = this.layouts.find(layout => layout.id === this.existingLayout)
          }
        }
        this.$v.$reset()
        if (copyLayout) {
          this.$emit('createLayout', { name: this.name, info: this.info, existingLayout: copyLayout })
        } else {
          this.$emit('createLayout', { name: this.name, info: this.info })
        }
      }
    },
    tableRowClassName ({ row }: { row: { id: string }}): string {
      if (row.id === this.existingLayout) {
        return 'selected-row'
      }
      return ''
    },
    hideModal (): void {
      this.$emit('hideModal')
    },
    kisweRowClicked (row: { id: string }) {
      this.existingLayout = row.id
    }
  },
  components: {
    Modal,
    'el-tabs': Tabs,
    'el-tab-pane': TabPane,
    'el-table': Table,
    'el-table-column': TableColumn,
    LayoutPreview
  }
})
